import { c as _c } from "react/compiler-runtime";
import ButtonCommon from '@components/button-common/ButtonCommon';
import Switch from '@components/switch/Switch';
import arrowDown from '@images/svg/index/arrow-down.svg';
import cn from 'classnames';
import Image from 'next/image';
import Svg from 'react-inlinesvg';
import { CheckBox } from '../checkbox/CheckBox';
import styles from './ProgramsList.module.scss';
const SvgImg = t0 => {
  const $ = _c(4);
  const {
    svg,
    className,
    alt: t1
  } = t0;
  const alt = t1 === undefined ? "" : t1;
  if (!svg) {
    return null;
  }
  const src = `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
  let t2;
  if ($[0] !== alt || $[1] !== className || $[2] !== src) {
    t2 = <Image className={className} src={src} alt={alt} width={30} height={30} loading="lazy" />;
    $[0] = alt;
    $[1] = className;
    $[2] = src;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export const ProgramsList = t0 => {
  const $ = _c(22);
  const {
    programs,
    comparings,
    isLoading,
    onComparePrograms,
    onOpenForm,
    onOpenComparigsModal,
    onCleanComparings
  } = t0;
  if (programs.length === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className={styles.emptyList}><p>Нет подходящих программ</p></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== isLoading) {
    t1 = cn(styles.wrapper, {
      [styles.loading]: isLoading
    });
    $[1] = isLoading;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== comparings || $[4] !== onComparePrograms || $[5] !== onOpenForm || $[6] !== programs) {
    let t3;
    if ($[8] !== comparings || $[9] !== onComparePrograms || $[10] !== onOpenForm) {
      t3 = (group, idx) => {
        const {
          interestRateActual,
          creditTimeEnd,
          monthPayment
        } = group.aggregateValues;
        const isChecked = comparings.some(item => item.guid === group.guid);
        return <li key={`${group.guid}-${idx}`} className={styles.program}><details className={styles.content}><summary className={styles.summary}><div className={styles.title}>{group.name}</div><div className={styles.rate}>от {interestRateActual}%</div><div className={styles.credit}>до {creditTimeEnd} лет</div><div className={styles.payment}>{monthPayment.toLocaleString("ru-RU")} ₽</div><div className={styles.compare}><CheckBox id={`compare-${group.guid}`} checked={isChecked} onChange={e => onComparePrograms(e, group)} /></div><Switch handleSwitch={() => onOpenForm(group)} switchText={"\u041F\u043E\u0434\u0430\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443"} testId="openMortgageForm" someStyles={styles.cta} /><div className={styles.arrow}><Svg src={arrowDown.src} fill="#636363" /></div></summary>{group.programsData?.map(_temp)}<ButtonCommon type="button" handleFuction={onOpenForm} text={"\u041F\u043E\u0434\u0430\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443"} className={styles.bankProgramCta} /></details></li>;
      };
      $[8] = comparings;
      $[9] = onComparePrograms;
      $[10] = onOpenForm;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    t2 = programs.map(t3);
    $[3] = comparings;
    $[4] = onComparePrograms;
    $[5] = onOpenForm;
    $[6] = programs;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[12] !== t2) {
    t3 = <ul className={styles.list}>{t2}</ul>;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== comparings.length || $[15] !== onCleanComparings || $[16] !== onOpenComparigsModal) {
    t4 = comparings.length > 1 && <div className={styles.comparingsBtns}><ButtonCommon className={styles.show} text={`Сравнить программы (${comparings.length})`} handleFuction={onOpenComparigsModal} /><ButtonCommon className={styles.clean} text={"\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0432\u0441\u0451"} handleFuction={onCleanComparings} mainColor="White" /></div>;
    $[14] = comparings.length;
    $[15] = onCleanComparings;
    $[16] = onOpenComparigsModal;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== t1 || $[19] !== t3 || $[20] !== t4) {
    t5 = <div className={t1}>{t3}{t4}</div>;
    $[18] = t1;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
};
function _temp(bank) {
  return <div className={styles.bankProgram} key={bank.id}><div className={styles.title}>{Boolean(bank.bank.icon?.trim()) && <SvgImg svg={bank.bank.icon} className={styles.bankIcon} alt={bank.bank.bankName} />}{bank.bank.bankName}</div><div className={styles.rate}>от {bank.interestRateActual}%</div><div className={styles.credit}>до {bank.creditTimeEnd} лет</div><div className={styles.payment}>{bank.monthPayment.toLocaleString("ru-RU")} ₽</div><div /><div /><div /></div>;
}